import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import styled from 'styled-components'

// If we're specified (and non-empty), we'll be laid out as a full-width implicit row above
// `<AccommodationPackageOptionTileGrid/>`'s explicit grid at all breakpoints.
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
  grid-column: 1 / -1;
  grid-row: span 1 / 1;

  &:empty { display: none; }
`

function AccommodationSameRoomOptionTileHeaderArea(props: PropsWithChildren) {
  return <Container {...props} />
}

export default AccommodationSameRoomOptionTileHeaderArea
